import { authedGet } from "./api";
import { api_v3_get_tournament_details } from "../utils/constants";

export const getTournamentDetails = async (tournamentId, token) => {
  const url = api_v3_get_tournament_details(tournamentId);
  return authedGet(url, token);
};
